import isDefined from '../is-defined';
import isObject from '../is-object';

/**
 * Determines whether a variable is empty
 *
 * @param {mixed} variable - The variable being evaluated
 * @return  {boolean}   TRUE if the variable is empty
 */
const isEmpty = ( variable ) => {
	let response = true;

	// Check if the variable is defined, otherwise is empty
	if ( isDefined( variable ) ) {
		// Check if it's array
		if ( Array.isArray( variable ) ) {
			response = variable.length == 0;
		} else if ( isObject( variable ) ) {
			response = Object.keys( variable ).length == 0;
		} else {
			response = variable == '';
		}
	}

	return response;
};

export default isEmpty;
